/* =============================================================================
   DATOS ESTRUCTURADOS (schema.org)
   -----------------------------------------------------------------------------
   Lo que le dice a Google qué es este negocio, dónde está y qué servicios da.
   Es lo que puede hacer que aparezcan las preguntas desplegables en los
   resultados de búsqueda y que el negocio salga bien en el panel local.

   Se usa desde dos sitios:
     · src/mixins/seo.js      (navegación dentro del sitio)
     · scripts/prerender.js   (HTML estático del build)

   CommonJS a propósito, para que Node pueda leerlo sin compilar.
   ============================================================================= */

var SITE = require('./site').SITE;

function negocio() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': SITE.dominio + '/#organizacion',
    name: SITE.nombre,
    url: SITE.dominio,
    telephone: SITE.telefono,
    email: SITE.email,
    foundingDate: String(SITE.fundacion),
    address: {
      '@type': 'PostalAddress',
      streetAddress: SITE.direccion.calle,
      postalCode: SITE.direccion.codigoPostal,
      addressLocality: SITE.direccion.ciudad,
      addressRegion: SITE.direccion.provincia,
      addressCountry: SITE.direccion.pais
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: SITE.geo.lat,
      longitude: SITE.geo.lng
    },
    areaServed: SITE.areaServicio.map(function (n) {
      return { '@type': 'Place', name: n };
    })
  };
}

function servicio(data) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: data.h1,
    description: data.description,
    serviceType: data.kwPrincipal || data.h1,
    provider: { '@id': SITE.dominio + '/#organizacion' },
    areaServed: { '@type': 'Place', name: 'Tarragona' },
    url: SITE.dominio + data.url
  };
}

function faq(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(function (f) {
      return {
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a }
      };
    })
  };
}

function migas(lista) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: lista.map(function (m, i) {
      return {
        '@type': 'ListItem',
        position: i + 1,
        name: m.titulo,
        item: SITE.dominio + m.url
      };
    })
  };
}

/* Todos los bloques que corresponden a una página */
function construir(data) {
  var bloques = [negocio(), migas(data.migas), servicio(data)];
  if (data.faqs && data.faqs.length) {
    bloques.push(faq(data.faqs));
  }
  return bloques;
}

module.exports = {
  negocio: negocio,
  servicio: servicio,
  faq: faq,
  migas: migas,
  construir: construir
};
